import React from 'react';
interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'center' | 'left';
  light?: boolean;
}
export function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center',
  light = false
}: SectionHeaderProps) {
  return <div data-component="COMP-04-SectionHeader" className={`mb-12 md:mb-16 ${align === 'center' ? 'text-center mx-auto' : 'text-left'} max-w-3xl`} data-id="element-251">
      <span className={`block text-sm font-bold tracking-widest uppercase mb-3 ${light ? 'text-gold-400' : 'text-gold-700'}`} data-id="element-252">
        {eyebrow}
      </span>
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-6 ${light ? 'text-white' : 'text-navy-900'}`} data-id="element-253">
        {title}
      </h2>
      {description && <p className={`text-lg md:text-xl ${light ? 'text-navy-100' : 'text-navy-600'}`} data-id="element-254">
          {description}
        </p>}
    </div>;
}